import React from "react";
import { Box } from "@chakra-ui/react";
import { AutoComplete } from "components";
import { SURGEON_ROLES, useQueryParams } from "duck";

const Filters: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const doctors = params.filter?.doctors?.map((docId: string) => +docId);

  return (
    <Box width="240px">
      <AutoComplete.Users
        label="Doctors"
        labelHidden
        isMulti
        placeholder="Doctors"
        optionLabel={doctor => `${doctor.firstName} ${doctor.lastName}`}
        value={doctors || null}
        role={SURGEON_ROLES}
        onChange={value => {
          setParams({
            ...params,
            filter: { ...params.filter, doctors: value }
          });
        }}
        controlShouldRenderValue={false}
      />
    </Box>
  );
};

export default Filters;
